import React, { useState } from "react";

interface AudioPickerProps {
  onValidAudioSelected: (file: File) => void;
}

const AudioPicker: React.FC<AudioPickerProps> = ({ onValidAudioSelected }) => {
  const [validationMessage, setValidationMessage] = useState<string>("");

  const handleAudioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;

    if (file) {
      if (file.type !== "audio/mpeg") {
        setValidationMessage("Only MP3 format is supported.");
      } else {
        setValidationMessage("");
        onValidAudioSelected(file);
      }
    }
  };

  return (
    <div>
      <input type="file" accept="audio/mp3" onChange={handleAudioChange} />
      {validationMessage && <p style={{ color: "red", marginTop: "5px", marginBottom: "0" }}>{validationMessage}</p>}
    </div>
  );
};

export default AudioPicker;
